import React from 'react'
import PropTypes from 'prop-types'
import truncate from 'lodash/truncate'

import { useFlag } from '../FeatureFlag/use-flag'
import { MenuGroupsShape } from '../Menus/MenuGroups/MenuGroups'
import { HorizontalScrollMenu } from '../HorizontalScrollMenu/HorizontalScrollMenu'
import MoreNav from '../MoreNav/MoreNav'
import NavArrow from '../../assets/menu_nav_arrow.svg'
import { MenuGroupCarouselItem } from '../HorizontalScrollMenu/MenuGroupCarouselItem'

/**
 * Returns an array of items for use in the HorizontalScrollMenu or MoreNav
 * 1. filters out menus that dont have any items
 * 2. truncates the name of the item to <= 30 characters
 * @param {{ id: string, name:string, items: Array}[]} menus
 * @returns {*}
 */
export function getItemsFromMenus (menus) {
  return menus.reduce((acc, { id, name, items }) => {
    if (!items || !items.length) {
      return acc
    }
    return ([
      ...acc,
      {
        id,
        href: `#${id}`,
        title: name,
        name: truncate(name, {
          length: 30,
          omission: '...',
          // break on white space, +, - characters aiming to break on whole words rather than partial words
          separator: /[\W+-/]/
        })
      }
    ])
  }, [])
}

const MenusNav = ({ menus, activeItem }) => {
  const scrollableMenuGroupEnabled = useFlag('oo-v3-scrollable-menugroup-nav')

  if (!menus || menus.length <= 1) {
    return null
  }

  const items = getItemsFromMenus(menus)
  const sharedProps = { items, activeItemId: activeItem }

  if (scrollableMenuGroupEnabled) {
    return (
      <HorizontalScrollMenu
        {...sharedProps}
        rightArrowButton={NavArrow}
        leftArrowButton={NavArrow}
        activeItemId={sharedProps.activeItemId}
      >
        {items.map((item) => (
          <MenuGroupCarouselItem
            key={item.id}
            item={item}
            activeItemId={sharedProps.activeItemId}
          />
        ))}
      </HorizontalScrollMenu>
    )
  }

  return (
    <MoreNav
      {...sharedProps}
      getItemId={item => item.id}
    />
  )
}

MenusNav.propTypes = {
  menus: MenuGroupsShape.isRequired,
  activeItem: PropTypes.string
}

export default MenusNav
